namespace Solovis.Reports.Parts.Tables.DataTableHelpers {

    /*
     * ExpansionManager keeps track of expanded groups in the current data view.     
     */
    export class ExpansionManager {

        public tableControl: Solovis.Reports.Parts.Tables.DataTableControl;
        public _collapseAllByDefault: boolean;
        public _expandedGroupKeys;
        public _collapsedGroupKeys;
        public _flattenNestedGroupKeys;

        constructor(options) {
            var self = this;

            this.tableControl = options.tableControl;

            this._collapseAllByDefault = false;
            this._expandedGroupKeys = {};
            this._collapsedGroupKeys = {};
            this._flattenNestedGroupKeys = {};

            if (options.expansionSettings) {
                this._collapseAllByDefault = options.expansionSettings.collapseAllByDefault ? true : false;

                if (options.expansionSettings.expandedGroupKeysList) {
                    $(options.expansionSettings.expandedGroupKeysList).each(function (i, key: any) {
                        self._expandedGroupKeys[key] = true;
                    });
                }

                if (options.expansionSettings.collapsedGroupKeysList) {
                    $(options.expansionSettings.collapsedGroupKeysList).each(function (i, key: any) {
                        self._collapsedGroupKeys[key] = true;
                    });
                }

                if (options.expansionSettings.flattenedNestedGroupKeyList) {
                    $(options.expansionSettings.flattenedNestedGroupKeyList).each(function (i, key: any) {
                        self._flattenNestedGroupKeys[key] = true;
                    });
                }
            }

            // TODO: Decide on whether logic is needed for resetting groupings when table groupings change.
        }

        public isExpanded(nestedGroupKey) {
            if (this._collapseAllByDefault) {
                if (this._expandedGroupKeys[nestedGroupKey]) {
                    return true;
                }

                // Not specifically expanded, so it is collapsed.
                return false;
            }
            else {
                if (this._collapsedGroupKeys[nestedGroupKey]) {
                    return false;
                }

                // Not specifically collapsed, so it is expanded.
                return true;
            }
        }

        public collapseAll() {
            this._collapseAllByDefault = true;
            this._expandedGroupKeys = {};
            this._collapsedGroupKeys = {};

            this.notifyExpansionChanged();
        }

        public expandAll() {
            this._collapseAllByDefault = false;
            this._expandedGroupKeys = {};
            this._collapsedGroupKeys = {};

            this.notifyExpansionChanged();
        }


        public expandToDepth(level: number) {
            this._collapseAllByDefault = true;
            this._expandedGroupKeys = {};
            this._collapsedGroupKeys = {};

            let expandToDepthHelper = (row, currentLevel) => {
                if (currentLevel >= level) {
                    return;
                }

                if (row._nestedGroupKey) {
                    this._expandedGroupKeys[row._nestedGroupKey] = true;
                }

                if (row._rows) {
                    for (let childRow of row._rows) {
                        expandToDepthHelper(childRow, currentLevel + 1);
                    }
                }
            }

            let dataView = this.tableControl.dataView;
            if (dataView && dataView.processedRows) {
                for (let row of dataView.processedRows) {
                    expandToDepthHelper(row, 0);
                }
            }

            this.notifyExpansionChanged();
        }


        public expand(nestedGroupKey) {
            if (this._collapseAllByDefault) {
                this._expandedGroupKeys[nestedGroupKey] = true;
            }
            else {
                if (this._collapsedGroupKeys[nestedGroupKey]) {
                    delete this._collapsedGroupKeys[nestedGroupKey];
                }
            }

            this.notifyExpansionChanged();
        }

        public collapse(nestedGroupKey) {
            if (this._collapseAllByDefault) {
                if (this._expandedGroupKeys[nestedGroupKey]) {
                    delete this._expandedGroupKeys[nestedGroupKey];
                }
            }
            else {
                this._collapsedGroupKeys[nestedGroupKey] = true;
            }

            this.notifyExpansionChanged();
        }

        public unflattenAll(suppressNotification) {
            this._flattenNestedGroupKeys = {};

            if (!suppressNotification) {
                this.notifyExpansionChanged();
            }
        }



        public notifyExpansionChanged() {
            $(this).trigger("expansionChanged");
        }


        public getExpansionSettings() {
            var settings: any = {};

            settings.collapseAllByDefault = this._collapseAllByDefault;

            if (this._collapseAllByDefault) {
                var expandedGroupKeysList = [];

                for (var key in this._expandedGroupKeys) {
                    expandedGroupKeysList.push(key);
                }

                settings.expandedGroupKeysList = expandedGroupKeysList;
            }
            else {
                var collapsedGroupKeysList = [];

                for (var key in this._collapsedGroupKeys) {
                    collapsedGroupKeysList.push(key);
                }

                settings.collapsedGroupKeysList = collapsedGroupKeysList;
            }

            var flattenedNestedGroupKeyList = [];
            for (var flattenedNestedGroupKey in this._flattenNestedGroupKeys) {
                if (typeof flattenedNestedGroupKey === "string") {
                    flattenedNestedGroupKeyList.push(flattenedNestedGroupKey);
                }
            }
            if (!_.isEmpty(flattenedNestedGroupKeyList)) {
                settings.flattenedNestedGroupKeyList = flattenedNestedGroupKeyList;
            }

            return settings;
        }

        /**
         * Expand all sub-nodes within a particular group.
         */
        public expandAllWithinSubGroup(nestedGroupKey) {
            console.log("TODO: expandAllWithinSubGroup: " + nestedGroupKey);
        }

        /**
         * Collapse all sub-nodes within a particular group.
         */
        public collapseAllWithinSubGroup(nestedGroupKey) {
            console.log("TODO: collapseAllWithinSubGroup: " + nestedGroupKey);
        }

        /**
         * Flatten all sub-groups within a particular group to put them at same level.
         */
        public flattenSubGroup(nestedGroupKey) {
            this._flattenNestedGroupKeys[nestedGroupKey] = true;
            this.notifyExpansionChanged();
        }

        /**
         * Unflatten all sub-groups to undo the "flattenSubGroup" operation.
         */
        public unflattenSubGroup(nestedGroupKey) {
            delete this._flattenNestedGroupKeys[nestedGroupKey];
            this.notifyExpansionChanged();
        }

        public isFlattenedSubGroup(nestedGroupKey) {
            if (this._flattenNestedGroupKeys[nestedGroupKey]) {
                return true;
            }
            else {
                return false;
            }
        }

        /**
         * If the nestedGroupKey is within a flattened group key, return that nested group key; otherwise, return null.
         */
        public getFlattenedNestedGroupKeyIfWithinFlattenedSubGroup(nestedGroupKey) {
            if (typeof nestedGroupKey !== "string") {
                return null;
            }

            for (var flattenedNestedGroupKey in this._flattenNestedGroupKeys) {
                if (typeof flattenedNestedGroupKey === "string") {
                    if (nestedGroupKey.indexOf(flattenedNestedGroupKey) === 0) {
                        // Ensure we have the double-pipe divider after that.
                        if (nestedGroupKey.length >= flattenedNestedGroupKey.length + 2) {
                            if (nestedGroupKey[flattenedNestedGroupKey.length] == '|'
                                && nestedGroupKey[flattenedNestedGroupKey.length + 1] == '|') {
                                // Handle "||" divider for same-grouping, different level.
                                return flattenedNestedGroupKey;
                            }
                            else if (nestedGroupKey[flattenedNestedGroupKey.length] == '/'
                                && nestedGroupKey[flattenedNestedGroupKey.length + 1] == '/') {
                                // Handle "//" divider for new grouping category.
                                return flattenedNestedGroupKey;
                            }
                        }
                    }
                }
            }

            return null;
        }
    }

}
